import * as types from '../ActionTypes/BreakdownActionTypes';
import { getBreakdownModelsArray } from './helpers';

const initialState = {
    statuses: {
        isBreakdownLoading: false,
    },
    loadingBreakdownId: null,
    breakdowns: {},
};

export function BreakdownReducer(state = initialState, { type, payload, meta }) {
    switch (type) {
        case types.BREAKDOWN_GET_BY_ID_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isBreakdownLoading: true,
                    loadingBreakdownId: meta.breakDownId,
                },
            };
        }

        case types.BREAKDOWN_GET_BY_ID_SUCCESS: {
            const breakdownsArray = getBreakdownModelsArray(payload);

            let counter = 0;
            let breakdownsObject = {};
            const withIndexProp = breakdownsArray.filter(bd => bd.time !== 0 && bd.time !== null).map(breakDown => {
                if (breakDown.exerciseId === 276) {
                    return breakDown;
                } else {
                    counter += 1;
                    return { ...breakDown, index: counter };
                }
            });

            breakdownsObject[state.statuses.loadingBreakdownId] = [...withIndexProp];

            return {
                ...state,
                breakdowns: { ...state.breakdowns, ...breakdownsObject },
                loadingBreakdownId: null,
                statuses: {
                    ...state.statuses,
                    isBreakdownLoading: false,
                },
            };
        }

        case types.BREAKDOWN_GET_BY_ID_FAILED: {
            return {
                ...state,
                statuses: {
                    isBreakdownLoading: false,
                },
                loadingBreakdownId: null,
            };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/BreakdownReducer.js